<!-- 已确认的页面 -->
<template>

    <div id="Confirmed">
        
        <HeaderInfo />


    </div>
   
</template>

<script>

import HeaderInfo from './HeaderInfo.vue'
export default {
    name:"Confirmed",
    components:{
        HeaderInfo
    }
}
</script>

<style scoped>

</style>